import { Language } from "../components/Localization";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/").replace(/\/$/, "");

export type PageContentItem = {
  id: string;
  kind: "text" | "image" | "audio" | "video";
  sortOrder: number;
  label: string | null;
  textContent: string | null;
  url: string | null;
  mimeType: string | null;
  width: number | null;
  height: number | null;
  durationMs: number | null;
};

type PageResponse = {
  status: "Success";
  result: PageResult;
};

export type PageGameItem = {
  id: string;
  contentItemId: string;
  kind: "text" | "image";
  pairIndex: number | null;
  roundIndex: number | null;
  sortOrder: number;
  isCorrect: boolean | null;
  textContent: string | null;
  url: string | null;
};

export type PageGame = {
  id: string;
  type: "match_image_text" | "scratch_reveal" | "match_text_image" | "guess_text" | "escape";
  nameHu: string;
  nameRo: string;
  items: PageGameItem[];
};

export type PageResult = { items: PageContentItem[]; games: PageGame[] };

export async function getPage(slug: string, locale: Language, signal?: AbortSignal) {
  const response = await fetch(
    `${API_BASE_URL}/api/pages/${encodeURIComponent(slug)}/${encodeURIComponent(locale)}`,
    { signal },
  );

  if (!response.ok) throw new Error(`Page request failed: ${response.status}`);

  const data = await response.json() as PageResponse;
  return {
    ...data.result,
    items: data.result.items.slice().sort((first, second) => first.sortOrder - second.sortOrder),
  };
}
